import { TASK_FIELDS } from 'utils/formFields/task';
import { USER_FIELDS } from 'utils/formFields/user';
import { optionalFormField } from 'utils/methods/helpers';
import { severityRatingOptions } from 'containers/Pages/Events/Layouts';
import { EventPlaceholder } from 'utils/constants/eventStatus';
import { patrolFormFields } from 'utils/patrol';
import { GEOGRAPHICAL_MAP } from 'utils/constants/Map';
import isEmpty from 'lodash/isEmpty';
import { taskIconSelector } from 'containers/Task/Form/options';
import { TASK_MODEL } from 'services/entity/task';
import { LIST_WIDTH } from 'utils/constants/listview';
import { DEFAULT_EMPTY_VALUE } from 'utils/constants';
import { isJSON } from 'utils/checkImage';
import { TASK_EVIDENCE_TYPE, TASK_STATUS } from 'utils/constants/task';
import { fromJSON } from 'utils/helper/baseTasks';
import { AccountHolderAndAbove } from 'utils/helper/roles';

export const generalSectionFields = ({
  services = [],
  view,
  userAssignedDepartments = [],
  hideAssignee = false,
  securityCompanyId,
}) => {
  return [
    TASK_FIELDS.name({ size: 'half', disabled: true }),
    TASK_FIELDS.taskType({
      archived: false,
      services,
      view,
      size: 'half',
      required: true,
      disabled: true,
    }),
    ...optionalFormField({
      showWhen: !hideAssignee,
      field: TASK_FIELDS.assignee({
        view: view,
        size: 'half',
        disabled: true,
      }),
    }),
    ...optionalFormField({
      showWhen: userAssignedDepartments.length > 0,
      field: USER_FIELDS.departments({
        userAssignedDepartments,
        disabled: true,
      }),
    }),

    {
      field: 'severityRating',
      type: 'select',
      label: 'Severity Rating',
      options: severityRatingOptions,
      size: 'half',
      disabled: true,
    },
    {
      field: 'severity',
      type: 'text',
      label: 'Severity Description',
      maxLength: 50,
      placeholder: EventPlaceholder.severity,
      disabled: true,
    },
    ...optionalFormField({
      showWhen: true,
      field: {
        field: 'site',
        type: 'async-select',
        required: false,
        size: 'half',
        valueType: 'object',
        disabled: true,
        optionLabelKey: 'name',
      },
    }),
    TASK_FIELDS.linkAssetId({
      securityCompanyId,
      archived: false,
      size: 'half',
      disabled: true,
    }),
  ];
};

export const detailedSectionFields = ({
  siteLocation,

  showPolylines,

  center,

  isRootTask,
  scheduleActiveTab,
  schedulingView,

  multiSchedule,

  editMode,
  selectedSiteDetailImages,
  surfaceImage,
  location = [],
  selectedTaskType,
}) => {
  return [
    TASK_FIELDS.description({ disabled: true }),
    TASK_FIELDS.checkListRequired({ disabled: true }),
    TASK_FIELDS.evidenceRequired(null, true, true),

    ...optionalFormField({
      showWhen: isRootTask && !multiSchedule,
      field: TASK_FIELDS.schedule({
        activeTab: scheduleActiveTab,
        displayView: schedulingView,
        editMode,
        disabled: true,
      }),
    }),
    ...optionalFormField({
      showWhen: isRootTask,
      field: TASK_FIELDS.expectedDuration({ disabled: true }),
    }),

    ...optionalFormField({
      showWhen: !isEmpty(selectedTaskType),
      field: patrolFormFields.siteSurfaceImages({
        options: selectedSiteDetailImages,
        useSelectedValue: true,
        valueType: 'object',
        defaultValue: GEOGRAPHICAL_MAP,
        showPopup: true,
        disabled: true,
        surfaceTouched: location.length > 0,
      }),
    }),
    ...optionalFormField({
      showWhen:
        surfaceImage.id === GEOGRAPHICAL_MAP.id && !isEmpty(selectedTaskType),
      field: TASK_FIELDS.location({
        siteLocation,
        showPolylines,
        center,
        // singleMarkerIcon: mapIconSelector(selectedTaskType), // pass this or typeOfIcon
        singleMarkerIcon: taskIconSelector(selectedTaskType), // pass this or typeOfIcon
        // typeOfIcon: 'CHECKPOINT', // type of icon for first point
        displaySites: true, // displays all the sites on map
        disabled: true,
      }),
    }),

    ...optionalFormField({
      showWhen:
        surfaceImage.id !== GEOGRAPHICAL_MAP.id && !isEmpty(selectedTaskType),
      field: TASK_FIELDS.imageArtist({
        showPolylines,
        selectedSiteDetailImages: surfaceImage,
        singleMarkerIcon: taskIconSelector(selectedTaskType),
        // singleMarkerIcon: mapIconSelector(selectedTaskType),
        // typeOfIcon: 'CHECKPOINT', // type of icon for first point
      }),
    }),
  ];
};
export const evidenceCollectionColumns = [
  {
    field: TASK_MODEL.evidence.type.id,
    headerName: TASK_MODEL.evidence.type.label,
    width: LIST_WIDTH.sm,
  },
  {
    headerName: TASK_MODEL.evidence.description.label,
    field: TASK_MODEL.evidence.description.id,
    width: LIST_WIDTH.lg,
  },
  {
    headerName: 'Contents',
    field: TASK_MODEL.evidence.contents.id,
    width: LIST_WIDTH.lg,
    cellRenderer: 'audioComponent',
  },
];
const formatContents = contents => {
  // check if the content is json string
  const isContentJSON = isJSON(contents);
  if (isContentJSON) {
    const parsedContent = fromJSON(contents);
    return parsedContent;
  }
  return DEFAULT_EMPTY_VALUE;
};
const contentValue = ({ type, contents }) => {
  // if the content is json then it must be new evidence type

  if (
    type === TASK_EVIDENCE_TYPE.OPTION_SINGLE.id ||
    type === TASK_EVIDENCE_TYPE.OPTION_MULTIPLE.id
  ) {
    return formatContents(contents);
  } else if (type === 'DESCRIPTION' || type === 'NUMERIC') {
    //for other type if evidence like image, audio, text etc
    return '';
  } else {
    return contents;
  }
};

export const transformEvidence = data => {
  if (!data)
    return [
      {
        rowData: {
          [TASK_MODEL.evidence.type.id]: DEFAULT_EMPTY_VALUE,
          [TASK_MODEL.evidence.description.id]: DEFAULT_EMPTY_VALUE,
          [TASK_MODEL.evidence.contents.id]: DEFAULT_EMPTY_VALUE,
        },
        allowEdit: false,
        allowDelete: false,
        rawData: {},
      },
    ];

  return data.map(item => {
    const { type, description, contents } = item;

    return {
      rowData: {
        [TASK_MODEL.evidence.type.id]: !isEmpty(type)
          ? type
          : DEFAULT_EMPTY_VALUE,
        [TASK_MODEL.evidence.description.id]: !isEmpty(description)
          ? description
          : DEFAULT_EMPTY_VALUE,
        [TASK_MODEL.evidence.contents.id]: {
          type,
          value: contentValue({ type, contents }),
        },
      },
      allowEdit: false,
      allowDelete: false,
      rawData: item,
    };
  });
};

export const operationalSectionFields = ({
  startTaskCb,
  endTaskCb,
  disableStartButton,
  disableEndButton,
  evidence,
  disabled,
}) => {
  return [
    {
      type: 'evidence-collection',
      field: 'evidenceCollection',
      columns: evidenceCollectionColumns,
      startTaskCb,
      endTaskCb,
      disableStartButton,
      disableEndButton,
      dataTransform: data => transformEvidence(data),
      tableValues: evidence,
      disabled,
    },
  ];
};

// the button will be enabled if the status is NEW or is IN-PROGRESS
const checkTaskStatus = details => {
  return (
    !isEmpty(details) &&
    (details.tasks[0].status === TASK_STATUS.IN_PROGRESS.id ||
      details.tasks[0].status === TASK_STATUS.NEW.id)
  );
};

// the button will be enabled if there is no assignee
const checkIfAssigneeIsMeOrBlank = ({ details, userInfo }) => {
  if (!isEmpty(details)) {
    if (details.tasks[0]?.assigneeId === null) {
      return true;
    }
    if (details.tasks[0]?.assigneeId === userInfo.general.id) {
      return true;
    }
  }
  return false;
};

// check if the correct service exists. Match the taskCategory with user services
const checkIfUserHasService = ({ details, userInfo }) => {
  return (
    !isEmpty(details) &&
    !isEmpty(userInfo) &&
    userInfo.details.services.includes(details.tasks[0]?.taskCategory)
  );
};
// if the account holder logs in
const checkIfAccountHolder = (userInfo = {}) => {
  return (
    !isEmpty(userInfo) &&
    userInfo.general.roles.some(s => AccountHolderAndAbove.includes(s))
  );
};

export const enablePerformTask = ({ details, userInfo }) => {
  return (
    checkTaskStatus(details) &&
    (checkIfUserHasService({ details, userInfo }) ||
      checkIfAccountHolder(userInfo)) &&
    checkIfAssigneeIsMeOrBlank({ details, userInfo })
  );
};
